import clsx from 'clsx';

import AemImage from '@/components/AemImage/AemImage';
import type {ImageModel} from '@/types/content';

type SmallCardContentProps = {
    title?: string;
    imageMedia?: ImageModel[];
    borderless: boolean;
};

const SmallCardContent = ({title, imageMedia, borderless}: SmallCardContentProps) => (
    <>
        <h2 className={clsx('m-0 font-bold text-lg text-white', borderless && 'px-4')}>{title}</h2>

        {imageMedia && imageMedia.length > 0 && (
            <div
                className={clsx(
                    'mt-auto flex w-full shrink-0 items-center justify-center overflow-hidden pt-4',
                    !borderless && 'rounded-2xl'
                )}
            >
                <AemImage
                    imageMedia={imageMedia}
                    className='h-full w-full'
                    pictureClassName='h-full w-full'
                    imgClassName='max-h-full max-w-full object-contain'
                />
            </div>
        )}
    </>
);

export default SmallCardContent;
